module.exports = __webpack_public_path__ + "static/media/vypiszivnost.f58f62c6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/vypiszivnost.pdf
// module id = 376
// module chunks = 0